/* Delivery estimate (external asset; see snippets/delivery-estimate.liquid).
   In-stock -> exact 'get it by <date>' computed client-side (today + N business days).
   Other buckets -> localized estimated window. Places the badge next to the price. */
(function () {
  var el = document.querySelector('[data-ew-delivery]');
  if (!el) return;
  var inStock = el.getAttribute('data-instock') === '1';
  var lead = parseInt(el.getAttribute('data-lead-days'), 10) || 6;
  var locale = el.getAttribute('data-locale') || 'es';
  var bucket = el.getAttribute('data-bucket') || '';
  var stockPrefix = el.getAttribute('data-stock-prefix') || '';
  var estPrefix = el.getAttribute('data-est-prefix') || '';
  var txt = el.querySelector('[data-deliv-txt]');
  var lcMap = { es: 'es-ES', en: 'en-GB', nl: 'nl-NL' };
  var lc = lcMap[locale] || 'es-ES';

  var bucketMap = {
    '1-2 meses': { en: '1-2 months', nl: '1-2 maanden' },
    'mas de 2 meses': { en: 'over 2 months', nl: 'meer dan 2 maanden' },
    'más de 2 meses': { en: 'over 2 months', nl: 'meer dan 2 maanden' },
    '1-2 semanas': { en: '1-2 weeks', nl: '1-2 weken' },
    '2-4 semanas': { en: '2-4 weeks', nl: '2-4 weken' },
    '3-4 semanas': { en: '3-4 weeks', nl: '3-4 weken' },
    '4-6 semanas': { en: '4-6 weeks', nl: '4-6 weken' }
  };

  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) n--; }
    return d;
  }

  if (inStock) {
    var d = addBusinessDays(new Date(), lead);
    var f = d.toLocaleDateString(lc, { weekday: 'long', day: 'numeric', month: 'long' });
    if (txt) txt.textContent = stockPrefix + ' ' + f;
    el.classList.add('ew-deliv--stock');
  } else {
    var b = bucket;
    if (locale !== 'es') {
      var m = bucketMap[bucket.toLowerCase()];
      if (m && m[locale]) b = m[locale];
    }
    if (txt) txt.textContent = estPrefix + ' ' + b;
  }

  try {
    var anchor = document.querySelector('.product__price');
    if (anchor && anchor.parentNode) {
      if (anchor.nextSibling) anchor.parentNode.insertBefore(el, anchor.nextSibling);
      else anchor.parentNode.appendChild(el);
    }
  } catch (e) {}
  el.hidden = false;
})();
